import styled from 'styled-components'

export const tabNotaFiscalStyles = {
  Container: styled.div`
    margin: 16px;
  `
}
